import { Component } from 'react'
import styled from '@emotion/styled'
import {
  Page,
  LeftHeader,
  KeyValueRow,
  Spacer,
  Box,
  UserInfoModal,
  SettingsModal,
  Icons,
  DashboardOperationsButtons,
  DashboardUserNoPlace,
  BugReportModal
} from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'
import { TmrWorkstation, TmrPlace, Users } from 'stylewhere/api'
import { AppStore, OperationReadingProvider, RfidReader, Router } from 'stylewhere/shared'
import { showToastError } from 'stylewhere/utils'

interface State {
  userModalVisible: boolean
  settingsModalVisible: boolean
  refreshCounter: number
  bugReportModalVisible: boolean
}

export default class Dashboard extends Component<{}, State> {
  state: State = {
    refreshCounter: 0,
    userModalVisible: false,
    settingsModalVisible: false,
    bugReportModalVisible: false
  }

  componentDidMount() {
    // nessuna operazione attiva: i prefissi da ignorare dell'ultima operazione non devono valere per la prossima
    // e una init ancora in attesa non deve scriverli dopo questo reset
    OperationReadingProvider.cancelPendingInit()
    RfidReader.setIgnoreReadingTagsWithPrefixes('')
  }

  setuserModalVisible = (userModalVisible: boolean) => this.setState({ userModalVisible })

  setBugReportModalVisible = (bugReportModalVisible: boolean) => this.setState({ bugReportModalVisible })

  setsettingsModalVisible = (settingsModalVisible: boolean) => this.setState({ settingsModalVisible })

  selectDefaultWorkstation = async (workstation: TmrWorkstation) => {
    await AppStore.saveDefaultWorkstation(workstation)
    Router.refresh()
  }

  getWorkstationValue = () => {
    if (!AppStore.defaultWorkstation) {
      return '---'
    }
    return AppStore.defaultWorkstation.description || AppStore.defaultWorkstation.code
  }

  onConfirmUserInfo = async (places: TmrPlace[], attrs: any) => {
    const user = AppStore.loggedUser
    if (user) {
      let attributes = user.attributes || {}
      attributes = {
        ...attributes,
        ...attrs
      }
      const placesToSave: string[] = []
      for (const element of places) {
        placesToSave.push(element.id)
      }
      if (user.userPlaces && user.userPlaces.length > 0) {
        for (const element of user.userPlaces) {
          placesToSave.push(element.id)
        }
      }

      const success = await Users.initUserInfo(placesToSave, attributes, AppStore.getUserSelfInitializationPolicy())
      if (success) {
        globalThis.location.reload()
      } else {
        showToastError(__(T.error.self_user_data))
      }
    }
  }

  refreshOperations = () => {
    globalThis.location.reload()
  }

  userName = () => {
    const user = AppStore.loggedUser
    const adminBadge = AppStore.isAdmin() ? <AdminBadge>admin</AdminBadge> : ''
    if (user) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {user.username}
          {adminBadge}
        </div>
      )
    }
    return '---'
  }

  render() {
    const { userModalVisible, settingsModalVisible, bugReportModalVisible, refreshCounter } = this.state
    return AppStore.canEditUserSelf() ? (
      <DashboardUserNoPlace onConfirmUserInfo={this.onConfirmUserInfo} />
    ) : (
      <Page title="Dashboard" header={null}>
        <Box flex row>
          <LeftHeader
            refreshOperation={this.refreshOperations}
            onBugReportClick={() => this.setBugReportModalVisible(true)}
          >
            <KeyValueRow
              style={{ width: '100%' }}
              onClick={() => this.setuserModalVisible(!userModalVisible)}
              label={__(T.misc.user)}
              value={this.userName()}
              image={<Icons.Info />}
            />
            <Spacer />
            <KeyValueRow
              label={__(T.misc.workstation)}
              style={{ width: '100%' }}
              value={this.getWorkstationValue()}
              optionModal={{
                onSelect: (item) => this.selectDefaultWorkstation(item[0]),
                field: 'description',
                options: AppStore.workstations ?? [],
                selected: [AppStore.defaultWorkstation],
                title: __(T.titles.select_workstation),
                searchable: true
              }}
            />
          </LeftHeader>
          <RightContainer>
            <DashboardOperationsButtons refreshCounter={refreshCounter} />
          </RightContainer>
        </Box>
        {bugReportModalVisible && (
          <BugReportModal visible={bugReportModalVisible} onClose={() => this.setBugReportModalVisible(false)} />
        )}
        {userModalVisible && (
          <UserInfoModal
            user={AppStore.loggedUser}
            onClose={() => this.setuserModalVisible(false)}
            visible={userModalVisible}
          />
        )}
        {settingsModalVisible && (
          <SettingsModal onClose={() => this.setsettingsModalVisible(false)} visible={settingsModalVisible} />
        )}
      </Page>
    )
  }
}

const RightContainer = styled.div`
  display: flex;
  flex: 1.5;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const AdminBadge = styled.div`
  font-size: 14px;
  line-height: 14px;
  background-color: #f43c3c;
  padding: 3px 8px;
  border-radius: 20px;
  color: #fff;
`
